import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../customs/skeleton/main";
const Main = lazy(() => import("../../components/settings/chapterSetup/main"));

const ChapterSetup = () => {
  return (
      <Suspense fallback={<PageSkeleton />}>
        <Main />
      </Suspense>
  );
};

export default ChapterSetup;
